import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

interface ProRouteProps {
  children: React.ReactNode
}

/** Requires both authentication and a Pro plan. Redirects to /billing if not Pro. */
export default function ProRoute({ children }: ProRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-neutral-700 border-t-primary-500" aria-label="Loading" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (user?.plan !== 'pro') {
    return <Navigate to="/billing" replace />
  }

  return <>{children}</>
}
